import state from './moduleSelfServiceState'
import mutations from './moduleSelfServiceMutation'
import actions from './moduleSelfServiceActions'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: {
    getClientSessionId: (state) => state.clientSessionId,
    getActivePersonal: (state) => state.activePersonal,
    getScreenLock: (state) => state.screenLock,
    getPinEntryOpen: (state) => state.pinEntryOpen,
    getLossMode: (state) => state.isLossModeOn,
    getLossType: (state) => state.lossTypeSelection,
    getSelectedProduct: (state) => state.selectedProduct,
    getPreSelectedProduct: (state) => state.preSelectedProduct,
    getCurrentCart: (state) => state.carts.find((x) => x.active),
    getCarts: (state) => state.carts,
    getIsLoading: (state) => state.isLoading,
    getPersonList: (state) => state.personList,
    getToUpdateEntry: (state) => state.toUpdateEntry,
    getToIsReset: (state) => state.isReset,
    getProductNavResetEpoch: (state) => state.productNavResetEpoch,
    getLastBillId: (state) => state.lastBillId,
    getPaymentMethods: (state) => state.paymentMethods,
    getSelectedPaymentMethod: (state) => state.selectedPaymentMethod,
    getSelectedLossStocks: (state) => state.selectedLossStocks,
    getCakeQuestioned: (state) => state.isCakeQuestioned,
    getNavigationQuestion: (state) => state.navigationQuestion,
    hasNeedNavigationByQuestion: (state) => state.hasNeedNavigationByQuestion,
    getDiscountReasons: (state) => state.discountReasons,
    getToLastBillId: (state) => state.lastBillId,
    getPaymentSessionState: (state) => state.paymentSessionState
  }
}

